import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api.js";
import { useAuth } from "../lib/auth.js";
import { Card, CardContent } from "../components/ui/card.js";

/** Redeems the magic-link token from the URL, then bounces into the app. */
export function LoginVerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // guard StrictMode double-invoke (token is single-use)
    ran.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing token");
      return;
    }
    api
      .verify(token)
      .then(() => refresh())
      .then(() => navigate("/", { replace: true }))
      .catch(() => setError("This link is invalid or has expired."));
  }, [params, navigate, refresh]);

  return (
    <div className="grid h-full place-items-center p-6 text-sm">
      {error ? (
        <Card>
          <CardContent className="p-8">
            <p className="text-destructive">{error}</p>
            <a className="mt-3 inline-block font-medium text-[var(--color-link)]" href="/login">
              Back to sign in
            </a>
          </CardContent>
        </Card>
      ) : (
        <p className="text-muted-foreground">Signing you in…</p>
      )}
    </div>
  );
}
